import { EnvelopeIcon, ExclamationCircleIcon } from "@heroicons/react/16/solid";

export const Input: React.FC<
  Pick<
    React.InputHTMLAttributes<HTMLInputElement | HTMLTextAreaElement>,
    "name" | "type" | "value" | "onChange" | "onBlur" | "placeholder"
  > & {
    className?: string;
    label: React.ReactNode;
    error?: React.ReactNode;
    hint?: React.ReactNode;
    description?: React.ReactNode;
    textarea?: boolean;
  }
> = ({
  name,
  type,
  value,
  hint,
  onBlur,
  onChange,
  className,
  label,
  error,
  description,
  textarea,
  placeholder,
}) => {
  const errorClass = `col-start-1 row-start-1 block w-full rounded-md bg-white py-1.5 pr-10 text-base text-red-900 outline-1 -outline-offset-1 outline-red-300 placeholder:text-red-300 focus:outline-2 focus:-outline-offset-2 focus:outline-red-600 sm:pr-9 sm:text-sm/6 ${
    type === "email" ? "pl-10" : "pl-3"
  }`;
  const okClass = `col-start-1 row-start-1 block w-full rounded-md bg-white pr-3 py-1.5 text-base text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:text-sm/6 ${
    type === "email" ? "pl-10" : "pl-3"
  }`;
  return (
    <div className={className} data-error={error ? "true" : undefined}>
      <div className="flex justify-between">
        <label
          htmlFor={name}
          className="block text-sm/6 font-medium text-gray-900"
        >
          {label}
        </label>
        {hint && <span className="text-sm/6 text-gray-500">{hint}</span>}
      </div>
      <div className="mt-2 grid grid-cols-1">
        {textarea ? (
          <textarea
            name={name}
            rows={4}
            value={value}
            onChange={onChange}
            onBlur={onBlur}
            aria-invalid={!!error}
            placeholder={placeholder}
            aria-describedby={
              error
                ? `${name}-error`
                : description
                ? `${name}-description`
                : undefined
            }
            className={error ? errorClass : okClass}
          />
        ) : (
          <>
            <input
              name={name}
              type={type}
              value={value}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={placeholder}
              aria-invalid={!!error}
              aria-describedby={
                error
                  ? `${name}-error`
                  : description
                  ? `${name}-description`
                  : undefined
              }
              className={error ? errorClass : okClass}
            />
            {type === "email" && (
              <EnvelopeIcon
                aria-hidden="true"
                className="pointer-events-none col-start-1 row-start-1 ml-3 size-5 self-center text-gray-400 sm:size-4"
              />
            )}
          </>
        )}
        {error && (
          <ExclamationCircleIcon
            aria-hidden="true"
            className="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-red-500 sm:size-4"
          />
        )}
      </div>
      {error && (
        <p id={`${name}-error`} className="mt-2 text-sm text-red-600">
          {error}
        </p>
      )}
      {description && !error ? (
        <p id={`${name}-description`} className="mt-2 text-sm text-gray-500">
          {description}
        </p>
      ) : null}
    </div>
  );
};
